import installAdvancedLinkPlugin from '@plone/volto-slate/editor/plugins/AdvancedLink';
import { LINK, SIMPLELINK } from '@plone/volto-slate/constants';

/**
 * Buttons of the text editor toolbar in the order of the old volto-slate
 * 6.4.0, which ran the editor until #22837. The editor of Volto 19 leaves out
 * underline, heading four and clear formatting.
 */
export const TOOLBAR_BUTTONS = [
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'separator',
  'heading-two',
  'heading-three',
  'heading-four',
  'separator',
  'clearformatting',
  'separator',
  'sub',
  'sup',
  'separator',
  'bulleted-list',
  'numbered-list',
  'blockquote',
  LINK,
  'styleMenu',
];

/**
 * Inline elements a block keeps when it becomes a heading. The old volto-slate
 * kept all of them, Volto 19 only italic (`em`, `i`) and removes bold,
 * underline and links.
 */
export const HEADLINE_ELEMENTS = [
  'em',
  'i',
  'strong',
  'b',
  'u',
  'del',
  's',
  'sub',
  'sup',
  'code',
  LINK,
  SIMPLELINK,
];

/**
 * Sets up the text editor of Volto 19 like the old volto-slate add-on. The
 * AdvancedLink plugin stores links with the type `a` and the target in
 * `data.link` (internal, external or email), the format of all links in the
 * intranet; the simple link of Volto (type `link`, `data.url`) would show them
 * as paragraphs without a link. Its link dialog has no hash link, which did
 * not work (#21329, #21368). The toolbar gets the buttons of the old editor
 * back, and a heading keeps the formatting and the links of the text (#22837).
 * @function installSlateEditor
 * @param {Object} config Volto configuration
 * @returns {Object} Volto configuration
 */
export const installSlateEditor = (config) => {
  config = installAdvancedLinkPlugin(config);
  const { slate } = config.settings;
  slate.toolbarButtons = TOOLBAR_BUTTONS.filter((name) => slate.buttons[name]);
  slate.allowedHeadlineElements = [...HEADLINE_ELEMENTS];
  return config;
};

export default installSlateEditor;
